import { render, staticRenderFns } from "./SponsoredRecommendationMidrollOverlay.vue?vue&type=template&id=49efe096&scoped=true"
import script from "./SponsoredRecommendationMidrollOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./SponsoredRecommendationMidrollOverlay.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SponsoredRecommendationMidrollOverlay.vue?vue&type=style&index=0&id=49efe096&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49efe096",
  null
  
)

export default component.exports